import { createClient } from '@supabase/supabase-js';

// To be more secure: .env file. 
const supabaseURL = "https://wmyqlfkcgtlerlxczeac.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndteXFsZmtjZ3RsZXJseGN6ZWFjIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODc5NjQ4NTQsImV4cCI6MjAwMzU0MDg1NH0.nQYwJDtFOue0px0bdG4NgEI7Do--XjopPj8VFtpo6MM";

export const supabase = createClient(supabaseURL, supabaseAnonKey);